export default "__VITE_ASSET__a66330fa__"